var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleGlazed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36765 2.8855V2.24358C7.36765 1.60481 7.95836 1.12979 8.58225 1.26687L14.6838 2.60752M7.36765 2.8855L3.231 1.90337C2.60278 1.75422 2 2.23065 2 2.87633V13.4322V21.6091C2 22.2926 2.67053 22.7747 3.3185 22.557L7.36765 21.1965M7.36765 2.8855V11.5831M7.36765 21.1965L7.35745 21.6298C7.34151 22.3073 7.98984 22.8041 8.63988 22.6125L14.6626 20.8375M7.36765 21.1965V11.5831M7.36765 11.5831L22 12M22 12V17.9272C22 18.3706 21.708 18.761 21.2827 18.8864L14.6626 20.8375M22 12V5.01918C22 4.54958 21.6733 4.14325 21.2146 4.04247L14.6838 2.60752M14.6838 2.60752L14.6626 20.8375",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleGlazed);
export default __webpack_public_path__ + "static/media/double_glazed.a8389282987811b62b4a9c06b76a5f70.svg";
export { ForwardRef as ReactComponent };